/*
 * @Descripttion:
 * @version:
 * @Author: pengmiaopei
 * @Date: 2021-09-18 09:24:57
 * @LastEditors: pengmiaopei
 * @LastEditTime: 2022-05-18 12:00:10
 * @Description: file content
 * @FilePath: \Design_Vue_pmp\src\utils\viewInit.js
 */
//加载模型
export function viewerInit(inPath, inPage, inDom, cb) {
  var config = {
    memory: {
      limit: 0,
    },
  }
  var pdfExt
  //V7.9
  var viewer = new Autodesk.Viewing.GuiViewer3D(inDom, config)
  viewer.container.style.width = `${inDom.clientWidth}px`
  viewer.container.style.height = '100%' //`${height}px`;
  var options = {
    env: 'Local',
    path: inPath,
    withCredentials: false,
  }
  Autodesk.Viewing.Initializer(options, function() {
    viewer.initialize()
    var mat = new THREE.Matrix4()
    var loadOptions = {
      placementTransform: mat,
      globalOffset: {
        x: 0,
        y: 0,
        z: 0,
      },
    }
    let _temp = inPath.split('.')
    if (_temp[_temp.length - 1] == 'pdf') {
      viewer.loadExtension('Autodesk.PDF').then((ext) => {
        pdfExt = ext
        viewer.loadModel(inPath, {
          page: inPage,
          withCredentials: false,
        })
      })
    } else {
      viewer.loadModel(options.path, loadOptions)
    }
  })

  viewer.addEventListener(Autodesk.Viewing.GEOMETRY_LOADED_EVENT, function() {
    viewer.setReverseZoomDirection(true) //设置滚轮方向
    viewer.setGhosting(false) //隐藏去除残影
    viewer.setProgressiveRendering(true) //开启渐进式渲染
    //viewer.createViewCube(); //生成小房子按钮 此方法在V7.9中不适用
    //viewer.displayViewCube(true); //生成Cube 此方法在V7.9中不适用

    viewer.loadExtension('Autodesk.DocumentBrowser')
    // var viewCube = new Autodesk.Extensions.ViewCubeUi.ViewCubeUi(viewer,{});
    // viewCube.displayViewCube(true);
    // //viewer.displayViewCube(true,true);
    cb(viewer)
    return viewer
  })
}
